export default __webpack_public_path__ + "static/media/property_373.42c0943b.png";